var hintbox = {};
(function($) {
    var HINTBOX_CLOSE_BTN_CLASS = 'hintbox_close-btn',
        HINTBOX_CLOSE_BTN_SELECTOR = '.'+ HINTBOX_CLOSE_BTN_CLASS,
        HINTBOX_OUTER_BOX_SELECTOR = '.hintbox',
        SVG_ICON_CANCEL = 'close-btn.svg';

    var HINTBOX_POSITION = {right: "right", left: "left", top: "top", bottom: "bottom"};

    var svg_cancel_path = 'portal/img/svg-icons/wg_ui/messages/' + SVG_ICON_CANCEL;

    var COOKIE_EXPIRED_DAYS = 123*365;

    var addCloseButton = function(el) {
        var template = '<div class="' + HINTBOX_CLOSE_BTN_CLASS + '">' +
                        '<span class="svg-icon js-svg-icon"' +
                        'data-src="' + STATIC_URL + svg_cancel_path + '">' +
                        '</span></div>';
        $(el).append(template);
    };

    var getHintBoxId = function(el){
        var id = $(el)[0].id;
        return '#' + id.substring(0, id.lastIndexOf('_'));
    };

    var setPosition = function(el) {
        var target = getHintBoxId(el),
            $target = $(target),
            pos = $(el).data('placement'),
            target_coord = $target[0].getBoundingClientRect(),
            target_size ={x: $target.outerWidth(), y: $target.outerHeight()},
            hintbox_size = { x: $(el).innerWidth(), y: $(el).innerHeight()},
            offset= {x: 20, y: 20},
            coord = {x: 0, y: 0},
            originalPos,
            midPointCoord;

        var win = $(window),
            win_size = {x: win.width(), y: win.height()},
            scroll = {x: win.scrollLeft(), y: win.scrollTop()};

        var arrowCoord = {x:0, y:0};

        originalPos = pos;

        midPointCoord = {x: target_coord.left + (target_size.x/2) + scroll.x - (offset.x/2),
                        y: target_coord.top + (target_size.y/2) + scroll.y - (offset.y/2)};

        if (pos != HINTBOX_POSITION.top && pos != HINTBOX_POSITION.bottom) {
            if ( (target_size.x + hintbox_size.x + (offset.x*2) > win_size.x) ||
                ((target_coord.right + offset.x + hintbox_size.x > win_size.x) && (pos == HINTBOX_POSITION.right))) {
                $(el).removeClass('hintbox__' + pos);
                pos = HINTBOX_POSITION.bottom;
                $(el).addClass('hintbox__' + pos);
            } else {
                $(el).removeClass('hintbox__' + pos);
                $(el).addClass('hintbox__' + originalPos);
            }
        }

        switch (pos) {
            case HINTBOX_POSITION.left:
                coord.y = target_coord.top - (hintbox_size.y - target_size.y)/2 + scroll.y;
                coord.x = target_coord.left - hintbox_size.x - offset.x;
                break;
            case HINTBOX_POSITION.bottom:
                coord.y = target_coord.bottom + offset.y + scroll.y;
                coord.x = target_coord.left - offset.x;
                break;
            case HINTBOX_POSITION.right:
                coord.y = target_coord.top - (hintbox_size.y - target_size.y)/2  + scroll.y;
                coord.x = target_coord.left + target_size.x + offset.x + scroll.x;
                break;
            case HINTBOX_POSITION.top:
                coord.x = target_coord.left - offset.x;
                coord.y = target_coord.top - hintbox_size.y - offset.y + scroll.y;
                break;
        }

        if (coord.x + hintbox_size.x > win_size.x){
            coord.x = win_size.x - hintbox_size.x - offset.x;
        }

        function setArrowPosition() {
            return {x: (midPointCoord.x - coord.x)*100/hintbox_size.x,
                    y: (midPointCoord.y - coord.y)*100/hintbox_size.y};
        };

        function addArrow() {
            var arrowClass = "hintbox_arrow",
                arrowClassSelector = '.' + arrowClass,
                posClass = arrowClass + "__" + pos,
                outerClass = posClass + "-outer",
                outerClassSelector = '.' + outerClass,
                innerClass = posClass + "-inner",
                innerClassSelector = '.' + innerClass,
                template = '<span class="' + [arrowClass, outerClass].join(' ') +'"></span>' +
                            '<span class="' + [arrowClass, innerClass].join(' ') +'"></span>';

            if (!$(el +' span').hasClass(arrowClass)) {
                $(template).appendTo(el);
            } else {
                if ($(el + ' ' + arrowClassSelector)[0].className.indexOf(pos) < 0) {
                    $(el + ' ' + arrowClassSelector).remove();
                    $(template).appendTo(el);
                }
            }
            arrowCoord = setArrowPosition();

            if (pos == HINTBOX_POSITION.left || pos == HINTBOX_POSITION.right) {
                $(el + ' ' + outerClassSelector).css('top', Math.round(arrowCoord.y) + '%');
                $(el + ' ' + innerClassSelector).css('top', Math.round(arrowCoord.y) + 2 + '%');
            } else {
                $(el + ' ' + outerClassSelector).css('left', Math.round(arrowCoord.x) + '%');
                $(el + ' ' + innerClassSelector).css('left', Math.round(arrowCoord.x) + 1 + '%');
            }

        };

        addArrow();
        $(el).css({'left': coord.x, 'top':  coord.y});
    };

    var setExpiration = function(nDays){
        var currDate = new Date();

        currDate.setTime(currDate.getTime() + (nDays*24*60*60*1000));
        currDate = currDate.toUTCString();

        return ";expires=" + currDate;
    };

    var setCookie = function(name, value, nDays) {
        var expire = setExpiration(nDays);
        document.cookie = name + '=' + value + expire +'; path=/;';
    };

    var closeOnClick = function(selector, nDays) {
        $(selector).on('click', HINTBOX_CLOSE_BTN_SELECTOR , function () {
            $(this).parent().fadeOut(300);
            setCookie(selector, "yes", nDays);
        });
    };

    var displayHintbox = function(selector, nDays) {
        if ($(selector).length > 0) {
            setPosition(selector);
        }

        if (document.cookie.indexOf(selector) > -1) {
            $(selector).fadeOut(300);
        } else {
            $(selector).fadeIn(300);
            closeOnClick(selector, nDays);
        }
    };

    hintbox.Init = function(targetEl, initFactor) {
        var hintBoxEl = targetEl + '_hintbox';
        var usingHover = $(hintBoxEl).data('hover');

        if (!(usingHover)) {
            addCloseButton(hintBoxEl);
        }
        $('body').append($(hintBoxEl).detach());

        if (!(usingHover)) {
            $(initFactor).on('click tap', function() {
                if ($(hintBoxEl).find(HINTBOX_CLOSE_BTN_SELECTOR).length != 1) {
                    addCloseButton(hintBoxEl);
                    injectSVGs();
                }
                displayHintbox(hintBoxEl, COOKIE_EXPIRED_DAYS);
            });
            $(window).on('load resize', function(){
                displayHintbox(hintBoxEl, COOKIE_EXPIRED_DAYS);
            });
        } else {
             $(document).on('mouseenter mouseleave', targetEl, function() {
                 setPosition(hintBoxEl);
                 $(hintBoxEl).toggle();
            });
        }
    };

    $(function () {
        $(HINTBOX_OUTER_BOX_SELECTOR).each(function(){
            var elementId = getHintBoxId(this);
            hintbox.Init(elementId);
        });
    });
})(jQuery);